import type { CsvTerrificField } from '@entities/platform-entities/integration/csv-terrific-field.type';

export const CSV_OPTIONAL_TERRIFIC_FIELDS: readonly CsvTerrificField[] = [
  'availability',
  'color',
  'size',
  'sku',
] as const;
